import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ChargeReportPagination = ({ currentPage, totalPages, limit, onPageChange, onLimitChange, }) => {
    const maxVisiblePages = 5; // Nombre maximum de pages visibles
    const pages = [];
    if (totalPages <= maxVisiblePages) {
        for (let i = 1; i <= totalPages; i++) {
            pages.push(i);
        }
    }
    else {
        pages.push(1);
        if (currentPage > 3) {
            pages.push("...");
        }
        const startPage = Math.max(2, currentPage - 1);
        const endPage = Math.min(totalPages - 1, currentPage + 1);
        for (let i = startPage; i <= endPage; i++) {
            pages.push(i);
        }
        if (currentPage < totalPages - 2) {
            pages.push("...");
        }
        pages.push(totalPages);
    }
    return (_jsxs("div", { className: "flex justify-between items-center mt-4", children: [_jsx("select", { value: limit, onChange: e => onLimitChange(Number(e.target.value)), className: "border p-1 rounded", children: [10, 20, 50, 100].map(opt => (_jsx("option", { value: opt, children: opt }, opt))) }), _jsxs("div", { className: "flex items-center space-x-2", children: [_jsx("button", { onClick: () => onPageChange(Math.max(1, currentPage - 1)), className: `px-4 py-2 rounded ${currentPage === 1 ? "bg-gray-300 text-gray-500 cursor-not-allowed" : "bg-gray-200 hover:bg-gray-300"}`, disabled: currentPage === 1, children: "<" }), pages.map((page, index) => typeof page === "number" ? (_jsx("button", { onClick: () => onPageChange(page), className: `px-4 py-2 rounded ${currentPage === page ? "bg-blue-500 text-white" : "bg-gray-200 hover:bg-gray-300"}`, children: page }, index)) : (_jsx("span", { className: "px-4 py-2 text-gray-500", children: page }, index))), _jsx("button", { onClick: () => onPageChange(Math.min(totalPages, currentPage + 1)), className: `px-4 py-2 rounded ${currentPage === totalPages
                            ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                            : "bg-gray-200 hover:bg-gray-300"}`, disabled: currentPage === totalPages, children: ">" })] })] }));
};
export default ChargeReportPagination;
